<template>
  <div class="delivery-component d-flex align-center justify-space-between">
    <div class="delivery-title-section d-flex align-center">
      <div class="icon d-flex align-center">
        <icon-car />
      </div>
      <div class="delivery-title">
        <span class="sub-title">платная</span>
        <span class="font-weight-medium">Доставка</span>
      </div>
    </div>
    <div class="price">
      <span class="font-weight-medium">{{ price | amountStringWithCurrency }}</span>
    </div>
  </div>
</template>

<script>
  import IconCar from '@/components/icons/IconCar'

  export default {
    name: 'Delivery',
    components: {
      IconCar,
    },
    props: {
      price: {
        type: [String, Number],
        default: '',
      },
    },
  }
</script>

<style lang="less" scoped>
.delivery-component {
  margin-top: 20px;
  margin-bottom: 8px;
  padding: 18px 15px 20px 15px;
  background-color: @color-secondary;
  border-radius: 10px;

  .delivery-title-section {
    .icon {
      margin-right: 27px;
    }

    .delivery-title {
      span {
        font-size: 21px;
        display: block;
      }

      .sub-title {
        color: #7b7b7b;
        font-size: 12px;
        line-height: 1;
      }
    }
  }

  .price {
    span {
      font-size: 21px;
    }
  }
}
</style>
